//数组去重
export function unique (arr) {
  var res = [];
  var obj = {};
  if (arr.length) {
    for (var i = 0; i < arr.length; i++) {
      if (!obj[arr[i]]) {
        obj[arr[i]] = 1;
        res.push(arr[i]);
      }
    }
  }
  return res;
}
export function uuid32 () {
  let s = [];
  let hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = "-";
  let uuid = s.join("");
  return uuid;
}
export function getImageUrl (path) {
  return process.env.BASE_LINK + path;
}

export function getAvatarUrl (path) {
  if (path.startsWith('http')) {
    return path;
  }
  return process.env.BASE_LINK + path;
}

export function getPhone () {
  if (process.env.NODE_ENV == 'development') {
    return localStorage.getItem('phone');
  } else {
    return localStorage.getItem('phone');
  }
}

export function getUserId () {
  if (process.env.NODE_ENV == 'development') {
    return localStorage.getItem('userId');
    // return '8bc9994d-faa5-45bd-85b5-74ee0b76c9f5';
  } else {
    return localStorage.getItem('userId');
  }
}

export function getUserName() {
  if (process.env.NODE_ENV == 'development') {
    return localStorage.getItem('username');
  } else {
    return localStorage.getItem('username');
  }
}

export function getToken () {
  if (process.env.NODE_ENV == 'development') {
    return localStorage.getItem('token');
  } else {
    return localStorage.getItem('token');
  }
}

export function getOfficeToken () {
  return localStorage.getItem('internalOfficeToken');
  // if (process.env.NODE_ENV == 'development') {
  //   return localStorage.getItem('token');
  // } else {
  //   return localStorage.getItem('token');
  // }
}

export function clearUserInfo () {
  localStorage.clear();
  sessionStorage.clear();
}

export function getShareUrl (href) {
  if (localStorage.getItem('nbyg') == '1') { // 是否已内部员工认证成功
    return href + "share=1&phone=" + localStorage.getItem('phone') + '&nbyg=' + localStorage.getItem('nbygName');
  } else {
    return href + "share=1";
  }
}

export function clearCache (_this) {
  let vnode = _this.$vnode;
  let cache = _this.$vnode.parent
  if (cache) {
    let cacheInstance = cache.componentInstance
    let key = vnode.key == null ? vnode.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '')
      : vnode.key;
    cacheInstance.keys.splice(cacheInstance.keys.indexOf(key), 1)
    delete cacheInstance.cache[key]
  }
  _this.$destroy()
}

import { getUserByToken } from "@/request/login.js"
import androidinfo from "./androidinfo"
import { Toast } from 'vant';
export function getUserByTokenInfo (callback) {
  try {
    androidinfo.setToken(getToken())
  } catch (error) {
  }
  getUserByToken({
    token: getToken()
  }).then(res => {
    if (res.code == 0) {
      if (res.data.userDetails && res.data.userDetails.id) {
        localStorage.setItem("userId", res.data.userDetails.id) //用户id
        localStorage.setItem("username", res.data.userDetails.username) //username

        try {
          androidinfo.setUserId(getUserId())
          androidinfo.setUserName(res.data.userDetails.username)
        } catch (error) {
        }
      }
      let userBindInfo = res.data.userBindInfoVo;
      if (userBindInfo) {
        // if (userBindInfo.phone) { //登录人手机号码
        localStorage.setItem("phone", userBindInfo.phone)
        try {
          androidinfo.setPhone(userBindInfo.phone)
        } catch (error) {
        }
        // }
        // if (userBindInfo.phoneIsBind) {//是否绑定了手机号码
        localStorage.setItem("isBindPhone", userBindInfo.phoneIsBind)
        // }
        // if (userBindInfo.wxIsBind) {//是否绑定了微信
        localStorage.setItem("isBindWX", userBindInfo.wxIsBind)
        // }
        // if (userBindInfo.wx) {//绑定的微信信息
        localStorage.setItem("bind_wx_info", userBindInfo.wx)
        // }
        // if (userBindInfo.setPasswrod) {//是否设置密码
        localStorage.setItem("isSetPasswrod", userBindInfo.setPassword)
        // }
      }
      let userAuthInfoVo = res.data.userAuthInfoVo;
      if (userAuthInfoVo) {
        localStorage.setItem("nbygName", userAuthInfoVo.nbygName) //内部员工认证-真实姓名
        localStorage.setItem("nbyg", userAuthInfoVo.nbyg) //内部员工认证-真实姓名
      }
      if (callback) {
        callback(res.data)
      }
    } else {
      Toast(res.msg)
    }
  })
}

export function tabsClickScroll (refDom, e) {
  let scrollLeft = null
  let scrollRight = null
  let moveDistance = null
  let doms = document.getElementById(refDom)
  const clientWidthHalf = doms.scrollWidth / 3

  // e.clientX获取元素相对refDom元素的位置
  moveDistance = clientWidthHalf - e.clientX

  scrollLeft = moveDistance
  scrollRight = -(moveDistance)

  // 获取当前元素所在元素的中间位置
  const currentMiddleHalf = (clientWidthHalf + e.target.offsetWidth) / 2
  // 点击左侧
  // clientX 鼠标相比较于当前坐标系的位置,即如果触发元素没有设置绝对定位或相对定位,以页面为参考点,如果有,将改变参考坐标系
  if (e.clientX <= currentMiddleHalf) {
    doms.scrollLeft -= scrollLeft
  } else {
    // 点击右侧
    doms.scrollLeft += scrollRight
  }
  const res = doms.scrollLeft >= 0 ? doms.scrollLeft : 0

  doms.scrollLeft = res
  sessionStorage.setItem('tabLeft', res)
}

import router from "../router";
export function showImg (e) {
  if (e.target.tagName == 'IMG' && e.target.alt != 'drHengIcon') {
    router.push({ path: 'picturePreview', query: { url: e.target.src } })
  }
}

/**
 * 中间省略号
 */
export function lineMiddle (className, numLeft, numRight) {
  let textContainer = document.querySelector(className)
  let originalText = textContainer.textContent
  let containerWidth = textContainer.offsetWidth

  if (textContainer.scrollWidth > containerWidth) {
    textContainer.style.overflow = 'auto'
    let newText = '<span>' + originalText.substring(0, numLeft) + '</span>···<span>' + originalText.substring(originalText.length - numRight, originalText.length) + '</span>'
    textContainer.innerHTML = newText
  }
}

/**
 * 中间省略号
 * 列表加标记，有删除的需要
 */
export function lineMiddleById (eleId, originalText, numLeft, numRight, item) {
  let textContainer = document.getElementById(eleId)
  let containerWidth = textContainer.offsetWidth
  if (item['overTag'] || textContainer.scrollWidth > containerWidth) {
    item['overTag'] = true
    textContainer.style.overflow = 'auto'
    let newText = '<span>' + originalText.substring(0, numLeft) + '</span>···<span>' + originalText.substring(originalText.length - numRight, originalText.length) + '</span>'
    textContainer.innerHTML = newText
  } else {
    item['overTag'] = false
    textContainer.innerHTML = originalText
  }
}

/**
 * 文件图标
 */
export function getDocumentIcon (nameSuffix, name) {
  let str = ''
  if (nameSuffix != null && nameSuffix.length > 0) {
    str = nameSuffix.toLowerCase()
  } else {
    str = name.toLowerCase()
  }
  let icon = 'file_other'
  if (str != null && str.length > 0) {
    if (str.endsWith('.png') || str.endsWith('.jpg') || str.endsWith('.jpeg') || str.endsWith('.gif')) {
      icon = 'file_img'
    } else if (str.endsWith('.mp4') || str.endsWith('.avi') || str.endsWith('.wmv') || str.endsWith('.mov')) {
      icon = 'file_video'
    } else if (str.endsWith('.mp3') || str.endsWith('.m4a') || str.endsWith('.wav') || str.endsWith('.amr') || str.endsWith('.awb') || str.endsWith('.wma') || str.endsWith('.ogg')) {
      icon = 'file_audio'
    } else if (str.endsWith('.doc') || str.endsWith('.docx')) {
      icon = 'file_word'
    } else if (str.endsWith('.xls') || str.endsWith('.xlsx')) {
      icon = 'file_excel'
    } else if (str.endsWith('.pdf')) {
      icon = 'file_pdf'
    } else if (str.endsWith('.ppt')) {
      icon = 'file_ppt'
    } else if (str.endsWith('.zip')) {
      icon = 'file_zip'
    } else if (str.endsWith('.apk')) {
      icon = 'file_apk'
    } else if (str.endsWith('.txt')) {
      icon = 'file_txt'
    }
  } else {
    icon = 'file_other'
  }
  return 'static/imgs/' + icon + '.png'
}

/**
 * 判断文件是否是视频
 */
export function isVideo (nameSuffix, name) {
  let str = ''
  if (nameSuffix != null && nameSuffix.length > 0) {
    str = nameSuffix.toLowerCase()
  } else {
    str = name.toLowerCase()
  }
  if (str != null && str.length > 0) {
    if (str.endsWith('.mp4') || str.endsWith('.avi') || str.endsWith('.wmv') || str.endsWith('.mov')) {
      return true;
    }
  }
  return false;
}

/**
 * 从文件名称获取后缀，带.，如：.doc
 */
export function getFileExt (filename) {
  if (filename.length == 0) {
    return ''
  } else {
    let lastPoi = filename.lastIndexOf('.');
    if (lastPoi == -1) return "";
    return filename.substring(lastPoi);
  }
}

/**
 * 计算单个字符的平均宽度来估算在某个固定宽度下可以放置多少个字符
 * 这种方法并不完全准确，因为不同字符（如空格、标点符号、宽字符等）的宽度可能不同，而且字体、字体大小、字体粗细等因素也会影响字符的宽度
 * 
 */
export function estimateCharsInWidth (className) {
  // 获取容器元素
  const container = document.querySelector(className); // 匹配指定CSS选择器的第一个Element的方法
  // 如果容器不存在或没有宽度，则返回0
  if (!container || !container.offsetWidth) {
    return 0;
  }

  let maxWidth = container.offsetWidth;

  // 创建一个临时的span元素来测量字符宽度
  const measurer = document.createElement('span');
  measurer.style.visibility = 'hidden'; // 隐藏元素，避免干扰页面布局
  measurer.style.whiteSpace = 'nowrap'; // 防止换行
  measurer.style.font = container.style.font; // 确保使用相同的字体样式
  container.appendChild(measurer); // 将测量元素添加到容器中

  // 使用一个典型的字符（例如'W'）来测量宽度
  const testChar = '我';
  measurer.textContent = testChar;
  const charWidth = measurer.offsetWidth; // 获取字符宽度

  // 从容器中移除测量元素
  container.removeChild(measurer);

  // 计算可以放置的字符数（包括一些额外的空间以防字符紧密排列）
  const estimatedChars = Math.floor((maxWidth - 10) / charWidth); // 减去一些额外的空间作为缓冲
  return estimatedChars;
}


export function getMiddleText (text, maxLength) {
  if (!text) {
    return ''
  }
  if (maxLength == 0) {
    return ''
  }
  if (text.length <= maxLength) {
    return text
  }
  let middle = Math.floor(maxLength / 2);
  return text.substring(0, middle) + "..." + text.substring(text.length - middle, text.length)
}


// WEBPACK FOOTER //
// ./src/utils/utils.js